import React from 'react'
import PropTypes from 'prop-types'
//assets
import logo from '../assets/img/Sidebar__logo.svg';
import '../assets/css/IoT.css';
//router
import { BrowserRouter as Router, Route, Link, Switch, Redirect } from 'react-router-dom'
//components
import Avatar from '../components/Avatar';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import Dashboard from '../components/Dashboard';
import Events from '../components/Events';
import APIKey from '../components/APIKey';
//store
import userState from '../store/userState';
import panels from '../store/panels';
import profile from '../store/profile';
import events from '../store/events';
import prompt from '../store/prompt';
import dialog from '../store/dialog';
import { observer } from 'mobx-react';
//materialUI
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';





@observer
class IoT extends React.Component {
  state = {
    open: false,
  };
  componentDidMount() {
    if (userState.login) {
      profile.fetchProfile();
      events.fetchEvent();
      panels.fetchPanel();
    }
    console.log(this.props.match.url)
  }
  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    prompt.default();
  };
  handleDialogClose = (event) => {
    dialog.default();
  }
  handleDialogResult = (event) => {
    dialog.result = true;
    dialog.default();
  }
  render() {
    if (!userState.login) {
      return <Redirect to='/login' />
    }
    return (
      <div className="IoT">
        <Route path='/iot/:cat' render={({ match }) => (<Sidebar name='Coco Cloud' logo={logo} active={match.params.cat} />)} />
        <Avatar />
        <Route path='/iot/:cat' render={({ match }) => (<Navbar name={match.params.cat === 'events' ? '事件' : '儀表板'} />)} />
        <Route path='/iot/dashboard' component={Dashboard} />
        <Route path='/iot/events' component={Events} />
        <Route path='/iot/apikey' component={APIKey} />
        <Snackbar
          open={prompt.open}
          autoHideDuration={prompt.time}
          onClose={this.handleClose}
          message={prompt.content}
        >
        </Snackbar>
        <Dialog
          open={dialog.open}
          onClose={this.handleDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{dialog.title}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {dialog.content}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDialogClose} color="primary">
              Disagree
           </Button>
            <Button onClick={this.handleDialogResult} color="primary" autoFocus>
              Agree
           </Button>
          </DialogActions>
        </Dialog>
        {this.props.match.url == "/iot" && events && events.loading && <div style={{ position: 'absolute', top: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.6)' }}>
          <div className="donut"></div>
        </div>}
        {this.props.match.url == "/dashboard" && panels && panels.loading && <div style={{ position: 'absolute', top: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.6)' }}>
          <div className="donut"></div>
        </div>}
      </div>
    )
  }
}

export default IoT;



// WEBPACK FOOTER //
// ./src/container/IoT.js